import { useLingui } from "@lingui/react/macro";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { useTeams } from "@/api/Patients";
import { FilterPicker } from "./FilterPicker";
import { useTeamFilter } from "./useTeamFilter";

export const TeamFilterPicker = () => {
  const { t } = useLingui();
  const { data: enabledTeams, isPending, isError } = useTeams();
  const { selected, setSelected } = useTeamFilter();

  if (isPending) {
    return <Loading message={t`Hämtar team`} />;
  }

  if (isError) {
    return <ErrorMessage message={t`Kunde inte hämta team`} />;
  }

  const teamItems = enabledTeams.map((team) => ({
    id: team.id,
    label: team.displayName,
  }));

  return (
    <FilterPicker
      label={t`Team`}
      items={teamItems}
      selected={selected}
      onSelectionChange={setSelected}
    />
  );
};
